import { createAction, props } from '@ngrx/store';

import { TSettings } from '../../shared/services/appconfig/settings.model';

export const loadSettings = createAction('[Settings] Load Settings');

export const loadSettingsSuccess = createAction(
  '[Settings] Load Settings Success',
  props<{ settings: Partial<TSettings> }>()
);

export const loadSettingsFailure = createAction(
  '[Settings] Load Settings Failure',
  props<{ error: any }>()
);

export const updateSettings = createAction(
  '[Settings] Update Settings',
  props<{ settings: Partial<TSettings> }>()
);

export const updateSettingsSuccess = createAction(
  '[Settings] Update Settings Success',
  props<{ settings: Partial<TSettings> }>()
);

export const updateSettingsFailure = createAction(
  '[Settings] Update Settings Failure',
  props<{ error: any }>()
);
